// extracted by mini-css-extract-plugin
export default {"infinity-symbol":"lMBja","infinity-group":"qWH7I","infinity-unit":"sBeRK"};